import React from 'react';
import { css, Global } from "@emotion/react";
import theme from "../../../theme";
import Button from "../Button";

type Props = {
    children: any
};

type State = {
    hasError: boolean,
};

export default class ErrorBoundary extends React.Component<Props, State> {

    state = {
        hasError: false,
    };

    /**
     * Update state on error.
     *
     * @param error
     */
    static getDerivedStateFromError(error: Error) {
        // Update state so the next render will show the fallback UI.
        return process.env.NODE_ENV === 'development' ? null: { hasError: true };
    }

    /**
     * Reload the page.
     */
    reload = () => window.location.reload();

    /**
     * Render.
     */
    render() {
        if (this.state.hasError) {
            const containerStyle = css`
    background-color: ${theme.colours.white};
    box-shadow: ${theme.borderAndShadow.boxShadow};
    border-radius: ${theme.borderAndShadow.smallRadius};
    padding: 20px;
    max-width: 600px;
    margin: 100px auto 0 auto;
`;

            const textStyle = css`
    font-size: 1.6rem;
    font-family: ${theme.fonts.primary};
    margin: 0;
    color: ${theme.fonts.colour};
    text-align: center;
`;

            const buttonStyle = css`
    margin-top: 30px;
    text-align: center;
`;

            const bodyStyle =  css`
    body {
      background-color: ${theme.colours.grey[100]};
    }
`;

            return (
                <div css={containerStyle}>
                    <Global styles={bodyStyle} />
                    <p css={textStyle}>Oops, something has gone wrong.</p>
                    <div css={buttonStyle}>
                        <Button onClick={this.reload} size="lg">Reload</Button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}


